export default class CiiCurrentData {
    constructor(cii, noEffectCii, noFouling, noWindCii, startDateTime) {
        this.cii = cii;
        this.noEffectCii = noEffectCii;
        this.noFouling = noFouling;
        this.noWindCii = noWindCii;
        this.startDateTime = startDateTime;
    }

    get startDateTimestamp() {
        if (this.startDateTime) {
            return new Date(this.startDateTime).getTime();
        }
        return null;
    }
}
